import SectionDivider from "./SectionDivider";

export default function DashboardSection({ children, title, classList }) {
  return (
    <section
      className={`o-column ${
        classList ? classList : "u-margin--top_400 u-margin--bottom_400"
      }`}
    >
      <SectionDivider title={title} />
      {children}
    </section>
  );
}
